import Vue from "vue";
import Vuex from "vuex";
import { createSessionStorage } from "../vue-plugins/vuex-session";
import isEqual from "lodash-es/isEqual";

interface SearchState {
    [what: string]: string;
}

Vue.use(Vuex);

const store = new Vuex.Store({
    plugins: [ createSessionStorage("search") ],
    state: {
        search: {
            type: "",
            zipOrPlace: "",
            roomsFrom: "",
            roomsTo: "",
            priceFrom: "",
            priceTo: "",
        } as SearchState,
        searchResults: null, // To hide initial notfound message
        realestateResults: [],
        details: {},
    },
    mutations: {
        updateSearch(state, options) {
            // [TODO] options.action defines width search to do (purchase or ...)

            if (options.content) {
                if (isEqual(state.search[options.content.what], options.content.value)) { return; }
                state.search[options.content.what] = options.content.value;
            }

            const objectType = window.location.href.indexOf("liegenschaften") !== -1 ? "liegenschaften" : "rent";

            if ( objectType === "liegenschaften" ){
                fetch(`${window.$$currentPath}/.rest/wgn/v1/liegenschaften/search`, {
                    method: "GET",
                    // @ts-ignore: no Headers on IE
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin",
                    mode: "cors",
                    cache: "no-store",
                    // body: JSON.stringify(state.search),
                }).
                then((r: any) => r.ok ? r.json() : null).
                then((r: any) => state.realestateResults = r).
                catch( () => state.realestateResults = []);
            }

            if ( objectType === "rent" ){

                fetch(`${window.$$currentPath}/.rest/wgn/v1/rent/search`, {
                    method: "PUT",
                    // @ts-ignore: no Headers on IE
                    headers: {"Content-Type": "application/json"},
                    credentials: "same-origin",
                    mode: "cors",
                    cache: "no-store",
                    body: JSON.stringify(state.search),
                    // body: JSON.stringify({ uuid: this.id }),
                }).
                then((r: any) => r.ok ? r.json() : null).
                then(function(r: any) {
                    for(const item of r) {
                        if(item.rentNet && parseFloat(item.rentNet)){
                            item.rentBrutto = parseFloat(item.rentNet);

                            if(item.rentExtra && parseFloat(item.rentExtra)){
                                item.rentBrutto = item.rentBrutto + parseFloat(item.rentExtra);
                            }
                        }
                    }
                    return r;
                }).
                then((r: any) => state.searchResults = r).
                catch( () => state.searchResults = []);
            }
        },
        resetSearch(state) {
            state.search.type = "";
            state.search.zipOrPlace = "";
            state.search.roomsFrom = "";
            state.search.roomsTo = "";
            state.search.priceFrom = "";
            state.search.priceTo = "";
        },
        updatePlace(state, value) {
            // From Geolocalization - Save it on placeholder!
            state.search.zipOrPlace = value;
        },
        updateDetails(state, details) {
            state.details = details || {};
        },
    },
});

export { store };



// WEBPACK FOOTER //
// ./src/components/store.ts